import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {createScore, deleteScore, getScores, updateScore} from '../api/scoreApi';
import {NewScore} from "../types";

export const useScores = (category: string) => {
    const queryClient = useQueryClient();


    const {data: scores, isLoading} = useQuery({
        queryKey: ['scores', category],
        queryFn: () => getScores(category),
        enabled: !!category
    });

    const mutationCreate = useMutation({
        mutationFn: createScore,
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['scores']});
            queryClient.invalidateQueries({queryKey: ['categories']});

        },
    });

    const mutationUpdate = useMutation({
        mutationFn: ({id, score}: { id: string; score: NewScore }) => updateScore(id, score),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['scores']});
            queryClient.invalidateQueries({queryKey: ['categories']});

        },
    });

    const mutationDelete = useMutation({
        mutationFn: (id: string) => deleteScore(id),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['scores']});
            queryClient.invalidateQueries({queryKey: ['categories']});

        },
    });

    return {scores, isLoading, mutationCreate, mutationDelete, mutationUpdate};
};
